import { getAuth } from "firebase/auth";
import { getAuthCentral } from "../../config/FirebaseConfig";
import { getFirestore, doc, getDoc } from "firebase/firestore";
import { checkDB } from "../../models/DataFunctions.js";
import addLogDocument from "../addLogDocument"; // Assuming you have a function for logging

const sendInfiltreaCreateEnveloppeMission = async (
  folderid,
  operationid,
  operator_id,
  token,
  prefix
) => {
  // Define the endpoint URL
  const url =
    prefix + `infiltrea/operator/${operator_id}/create-enveloppe-mission`;

  // Define the request body
  const body = {
    folderid: folderid,
    operationid: operationid,
  };

  // Define headers
  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };

  try {
    // Make the POST request using fetch API
    const response = await fetch(url, {
      method: "POST",
      headers: headers,
      body: JSON.stringify(body), // Convert the body to JSON string
    });

    // Check if the response is OK
    if (!response.ok) {
      console.error(`Failed to create enveloppe mission: ${response.status}`);
      return `Failed to create enveloppe mission: ${response.status}`;
    }

    // Parse the response JSON
    const responseData = await response.json();

    const auth = getAuthCentral();
    const currentUser = auth.currentUser;

    if (!currentUser) {
      console.error("User not logged in");
      return "User not logged in";
    }

    const db = getFirestore();
    const userRef = doc(db, "user", currentUser.uid);
    const userSnapshot = await getDoc(checkDB(userRef));

    if (!userSnapshot.exists()) {
      console.error("User document not found");
      return "User document not found";
    }

    const org_id = userSnapshot.get("org_id");

    // Add log document
    await addLogDocument(
      url,
      prefix,
      userRef, // Log the userRef ID
      org_id,
      response.status.toString(), // Response status
      "", // folderid (if needed for logging)
      "", // docid (if needed for logging)
      JSON.stringify(body), // Request body as string
      JSON.stringify(responseData),
      "POST"
    );

    // Extract the ID from the response data (if available)

    return responseData;
  } catch (error) {
    // Handle exceptions
    console.error(`Exception occurred: ${error.message}`);
    return "";
  }
};

export default sendInfiltreaCreateEnveloppeMission;
